export const STORES_LIST_COLUMNS = [
	{ key: 'name', label: 'Store', tableOrder: 1 },
	{ key: 'sourceId', label: 'Store ID', tableOrder: 2 },
	{ key: 'streetAddress', label: 'Address', tableOrder: 3},
	{ key: 'storeHourStatus', label: 'Status', tableOrder: 4 },
];

export const TABLE_NAME = 'Stores';
export const TABLE_SUBTITLE = 'Click on a store to view or update store information. To add a new Saved List, make your selections then click the vertical dots icon to add list.';
export const STORES_PAGE_PLACEHOLDER = 'Search a Store ID';
export const AVAILABILITY = 'Availability';
export const SETTINGS = 'Settings';
export const BANKING = 'Banking';

export const AVAILABILITY_COLUMNS = [
	{ key: 'name', label: 'Name', tableOrder: 1 },
	{ key: 'date', label: 'Date', tableOrder: 2 },
	{ key: 'hours', label: 'Hours', tableOrder: 3}
];

export const AVAILABILITY_TABLE_NAME = 'Special Hours';
export const STORE_HOURS_TODAY_ARE_FROM = 'Store hours today are from';
export const REGULAR_HOURS = 'Regular Hours';
export const NOT_AVAILABLE = 'Not Available';
export const STORES = 'Stores';

export const STORE_NAME ='Store Name';
export const PAYOUT_FREQUENCY = 'Payout Frequency';
export const BANK_ACCOUNT_DETAILS = 'Bank Account Details';
export const WEEKLY = 'Weekly';
export const WEEKLY_PAYOUT_TEXT1 = 'Your payout frequency is currently set to a ';
export const WEEKLY_PAYOUT_TEXT2 = 'basis.';

export const BANKING_ACCOUNT_HOLDER_NAME = 'Account Holder Name';
export const BANKING_ACCOUNT_HOLDER_NUMBER = 'XXXXXXXXXX';
export const BANKING_ACCOUNT_ROUTING_NUMBER = 'XXXXXXXXXX';
export const BANKING_ROUTING_NUMBER = 'Routing Number';
export const BANKING_BANK_ACCOUNT_NUMBER = 'Linked Bank Account Number';
export const BANKING_REENTER_ACCOUNT_NUMBER = 'Re-enter Account Number';
export const BANKING_BUSINESS_LEGAL_ENTITY_NAME = 'Business Legal Entity Name';
export const BANKING_ADDRESS = 'Address';
export const BANKING_CITY = 'City';
export const BANKING_STATE = 'State';
export const BANKING_ZIP = 'Zip Code';

export const SETTINGS_STORE_DETAILS = 'Store Details';
export const SETTINGS_ORDER_SETTINGS = 'Order Settings';
export const SETTINGS_STORE_PHOTOS = 'Store Photos';
export const SETTINGS_LOGO = 'Logo';
export const SETTINGS_HEADER = 'Header';

export const SETTINGS_NAME = 'Name';
export const SETTINGS_PHONE_NUMBER = 'Phone Number';
export const SETTINGS_ADDRESS = 'Address';
export const SETTINGS_WEBSITE = 'Website';
export const SETTINGS_CUISINE_TYPE = 'Cuisine Type';
export const DEFAULT_TELEPHONE_NUMBER = '(XXX) XXX-XXXX';
export const SETTINGS_DRIVER_PICKUP_INSTRUCTIONS = 'Driver Pickup Instructions';
export const SETTINGS_STORE_PHOTOS_SUBTITLE = 'Accepted formats for images are PNG, JPEG, and TIFF. To update store photos, please reach out to support.';
export const SETTINGS_INSTRUCTIONS = 'Instructions';
export const SETTINGS_NONE = 'None';
export const SETTINGS_ENABLED = 'Enabled';
export const SETTINGS_NOT_SET_UP = 'Not Set Up';
export const SETTINGS_PICKUP_CONFIGURE = 'To configure or modify driver pickup instructions, please reach out to support.';
